export default {
  Studies: "Estudios",
  Layouts: "Ventanas",
  Sync: "Sincronización",
  scroll: "Desplazamiento",
  wwwc: "Niveles",
  zoom: "Zoom",
  general: "General",
  zooming: "Zoom",
  annotation: "Mediciones",
  rotating: "Rotaciones",
  Pan: "Mover",
  Wwwc: "Niveles por punto",
  WwwcRegion: "Niveles por región",
  Magnify: "Lupa",
  Zoom: "Zoom",
  Screen: "Captura",
  Rotate: "Girar",
  Flip: "Voltear",
  Reset: "Reiniciar",
  Eraser: "Borrador",
  ArrowAnnotate: "A - Etiqueta",
  Bidirectional: "Cruz",
  Angle: "Ángulo",
  EllipticalROI: "E - Elipse",
  FreehandRoi: "Línea libre",
  Length: "L - Regla",
  Probe: "Marcador puntual",
  RectangleRoi: "Rectángulo",
  TextMarker: "Marcadores de texto",
  DragProbe: "Sonda",
  ScaleOverlay: "Escalas",
  OrientationMarkers: "Marcadores de orientación",
  Brush: "Trazo libre",
  CircleScissors: "Elipse",
  FreehandScissors: "Figura libre",
  RectangleScissors: "Rectángulo",
  Invert: "Invertir",
  Clip: "Desplazamiento automático",
  Series: "Series",
  Report: "Informe",
  patientId: "ID del paciente",
  fullname: "Nombre completo",
  birthday: "Fecha de nacimiento",
  studyCreatedAt: "Fecha del estudio",
  old: "Edad",
  patientSex: "Sexo",
  "Result AI": "Resultado del análisis de IA",
  "Download dicom": "Descargar series de IA",
  "Download report": "Descargar informe",
  Loading: "Cargando",
  Cached: "en caché",
  male: "Masculino",
  female: "Femenino",
  Copy: "Copiar",
  "Copy ok": "Copiado",
  "Copy error": "No se pudo copiar el texto",
  Anonymized: "Anonimizado",
  StackScroll: "Desplazamiento",
  "Result after upload message":
    "Después del procesamiento, el informe estará disponible",
  "Result ai error message":
    "No se pudo procesar el estudio, intente cargar otro",
  error: "Error",
  "dcm cannot loading": "No se pudieron cargar archivos .dcm",
  "error read dcm": "Error al leer el estudio",
  ai: "Estudio con IA",
  original: "Estudio original",
  "How to use title": "Instrucciones para el uso del servicio",
  "How to use": "Instrucciones",
  "ai accept caption": "¿Es correcto el resultado del análisis de IA?",
  "thx for feedback": "¡Gracias por tus comentarios!",
  SelectedAccept: { 1: "Marcaste que el resultado", 2: "del análisis de IA" },
  "accept yes": "es correcto",
  "accept no": "es incorrecto",
  "View title": "Estudio | " + process.env.VUE_APP_INSTALL_NAME,
  Share: "Compartir",
  "Share done": "Hecho",
  "Share about": "El enlace se ha copiado al portapapeles",
  "Cancel preset": "Reiniciar",
  Description: "Descripción",
  "About study": "Tu respuesta",
  CheckReport: "Enviar",
  "Your description": "Tu respuesta",
  "Best description": "Descripción de referencia",
  "Teacher comment": "Comentario del instructor",
  "Answer exist": "Completado",
  "Answer not exist": "Sin respuesta",
  from: "de",
  "Skip all": "Omitir todo",
  "Add screenshot": "Capturar pantalla",
  "About screen info":
    "Puedes realizar anotaciones y adjuntar capturas (izquierda), presionando 'Capturar pantalla'. O subirlas desde tu computadora con el clip.",
  "Screenshot doned": "Captura guardada",
  PlanarFreehandROI: "R - Contorno",
  MPR: "MPR",
  "Disable MPR First": "Desactiva MPR primero",
  Crosshairs: "MIP y ejes",
  "MPR: only for 2+": "MPR no disponible",
  "MPR: hpu tier == 0":
    "Tu dispositivo no es lo suficientemente potente para crear reconstrucción",
  "MPR: modality not support":
    "MPR no es compatible con la modalidad <modality>",
  "Cannot loading screen -- adblock":
    "No se pudo cargar la captura. Desactiva extensiones como VPN o bloqueadores de anuncios",
  "Cannot loading screen -- s3 request":
    "No se pudo cargar la captura. Intenta más tarde o contacta con soporte",
  "Cannot loading screen -- upload":
    "No se pudo cargar la captura. Intenta más tarde o contacta con soporte",
  voi: "Brillo",
  camera: "Pan/Zoom",
  "Remove?": "¿Eliminar?",
  Support: "Soporte",
  "Support info": "Puedes hacer una consulta o reportar un problema",
  "Send work?": "¿Finalizar y enviar tu trabajo para revisión?",
  shareAIResult:
    "Consulta cómo la IA procesó el estudio en la Plataforma “" +
    process.env.VUE_APP_INSTALL_NAME +
    "”:",
  "Edit study": "Editar respuesta",
};
